module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "200px",
      "overflow": "hidden"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "src": _vm.$root.urlsite + 'documenti/backInside.png'
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24049d9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Image-inside.vue
// module id = 357
// module chunks = 0